<template>
  <div id="page-wrapper" v-if="loggedIn">
    <div class="wpr">
      <div class="payment">
        <img :src="bbpsImages.txnStatusIcon" alt="Be Assured" v-if="serviceType==='BBPS'" />
        <img src="/static/images/svgs/PaymentSuccess.svg" width="58px" />
        <p class="payment__caption payment__text">Payment Successful</p>
        <div class="payment__bbps-logo" v-if="serviceType==='BBPS'">
          <hr />
          <img class="payment__bbps-logo__img" :src="bbpsImages.txnStatusIcon" alt="Be Assured" />
          <hr />
        </div>
        <p class="payment__amount">{{ selectedPlan|formatCurrency }}</p>
        <div class="payment__transaction">
          <p class="payment__transaction--text">Transaction on</p>
          <p class="payment__transaction--date">{{new Date()|formatDate2}}</p>
        </div>
        <div class="payment__transaction" v-if="transactionInfo&&transactionInfo.transactionNumber">
          <p class="payment__transaction--text">Transaction ID</p>
          <p class="payment__transaction--date">{{transactionInfo.transactionNumber}}</p>
        </div>
        <router-link :to="{name: 'Dashboard'}">
          <ActionButton title="Go Home" />
        </router-link>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import ActionButton from "@/components/ActionButton/index";

export default {
  name: "EplNewTransactionSuccess",
  props: ["transactionInfo"],
  computed: {
    ...mapGetters(["loggedIn", "selectedPlan", "bbpsImages", "serviceType"])
  },
  components: { ActionButton },
  mounted() {
    this.$store.dispatch("storeMixpanelEvent", {
      eventName: "TRANSACTED",
      propertyName: "TRANSACTION_TYPE",
      propertyValue: "BILL_PAYMENT"
    });
    this.$store.dispatch("storeMixpanelEvent", {
      eventName: "TRANSACTED",
      propertyName: "AMOUNT",
      propertyValue: this.selectedPlan
    });
    this.$store.dispatch("storeMixpanelEvent", {
      eventName: "TRANSACTED",
      propertyName: "RESULT",
      propertyValue: "APPROVED"
    });
    this.$store.dispatch("storeMixpanelEvent", {
      eventName: "TRANSACTED",
      propertyName: "TXN_ID",
      propertyValue: this.transactionInfo.transactionNumber
    });
  }
};
</script>
<style lang="scss" scoped>
.wpr {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background: #ffffff;
}
.payment {
  text-align: center;
  color: #4d4d4d;
  width: 100%;
  padding: 0 3rem;
  &__caption {
    width: 100%;
    text-align: center;
    margin: 0 auto;
    margin-top: 30px;
  }

  &__text {
    font-size: 16px;
    letter-spacing: 0.34px;
  }
  &__amount {
    font-size: 34px;
    letter-spacing: 1.17px;
    font-weight: 900;
    margin-top: 65px;
    margin-bottom: 58px;
  }
  &__transaction {
    &--text {
      margin-bottom: 4px;
      color: #979797;
      font-size: 12px;
    }
    &--date {
      font-size: 14px;
      font-weight: 500;
      color: #4d4d4d;
    }
  }
  &__bbps-logo {
    display: flex;
    margin-top: 76px;
    align-items: center;
    &__img {
      width: 100%;
      height: auto;
      margin: 0 8px;
    }
    hr {
      width: 100%;
      margin: 0;
    }
  }
}

img {
  max-width: 80vw;
  max-height: 80vh;
}
</style>



// WEBPACK FOOTER //
// src/components/EplNewTransactionSuccess.vue